module.exports = __webpack_public_path__ + "static/img/applet-qr-code.26c5d77.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wechat/applet-qr-code.jpg
// module id = ijc4
// module chunks = 1